import { AuthorizationPolicy } from '@microsoft/microsoft-graph-types-beta';
import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

export const loadAuthorizationPolicy = createAction(
    '[Graph/authorization policy] Load Authorization Policy',
    props<{ _tenant: string }>(),
);

export const loadAuthorizationPolicySuccess = createAction(
    '[Graph/authorization policy] Load Authorization Policy Success',
    props<{ _tenant: string; policy: AuthorizationPolicy }>(),
);

export const loadAuthorizationPolicyFailure = createAction(
    '[Graph/authorization policy] Load Authorization Policy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateAuthorizationPolicy = createAction(
    '[Graph/authorization policy] Update Authorization Policy',
    props<{ _tenant: string; policy: Partial<AuthorizationPolicy> }>(),
);

export const updateAuthorizationPolicySuccess = createAction(
    '[Graph/authorization policy] Update AuthorizationPolicy Success',
    props<{ _tenant: string; policy: Partial<AuthorizationPolicy> }>(),
);

export const updateAuthorizationPolicyFailure = createAction(
    '[Graph/authorization policy] Update Authorization Policy Failure',
    props<{ _tenant: string; error: any }>(),
);
